import { setupNextraPage } from 'nextra/setup-page'
import __nextra_layout from 'nextra-theme-docs'
import __nextra_themeConfig from 'E:/pocket-tool/.pocket-doc/theme.config.tsx'

import 'nextra-theme-docs/style.css'
/*@jsxRuntime automatic @jsxImportSource react*/
// 弹出框高度
// 弹出框宽度
// 弹出框高度
// 弹出框宽度
// 弹出框高度
// 弹出框宽度
import {useMDXComponents as _provideComponents} from "nextra/mdx";
import InitMenu from "../../src/components/InitMenu";
import React, {useRef, useState} from "react";
import Popovers from "pocko-ui/Popovers";
import 'pocko-ui/Popovers/index.css';
export const Demo = () => {
  const _components = Object.assign({
    div: "div",
    button: "button",
    h2: "h2"
  }, _provideComponents());
  const popoverRef = useRef(null);
  return <_components.div className="mt-4">
      <Popovers ref={popoverRef} modalBodyHeight="220" modalBodyWidth="250" content={<_components.button className="btn btn-sm btn-primary text-dark" type="button">
            test
          </_components.button>} triggerShow={true}>
        <_components.h2>This is Popovers' content</_components.h2>
      </Popovers>
    </_components.div>;
};
export const Demo1 = () => {
  const _components = Object.assign({
    div: "div",
    button: "button",
    h2: "h2"
  }, _provideComponents());
  const popoverRef = useRef(null);
  return <_components.div class="d-flex align-items-center gap-4 mt-4">
      <Popovers ref={popoverRef} modalBodyHeight="100" modalBodyWidth="100" content={<_components.button className="btn btn-sm btn-primary text-dark" type="button">
            100px
          </_components.button>} triggerShow={true}>
        <_components.h2>Width: 100px</_components.h2>
        <_components.h2>Height: 100px</_components.h2>
      </Popovers>

      <Popovers ref={popoverRef} modalBodyHeight="300" modalBodyWidth="300" content={<_components.button className="btn btn-sm btn-info" type="button">
            300px
          </_components.button>} triggerShow={true}>
        <_components.h2>Width: 300px</_components.h2>

        <_components.h2>Height: 300px</_components.h2>
      </Popovers>
    </_components.div>;
};
export const __toc = [{
  depth: 4,
  value: "General",
  id: "general"
}, {
  depth: 4,
  value: "Customize Height or Width",
  id: "customize-height-or-width"
}, {
  depth: 4,
  value: "API",
  id: "api"
}, {
  depth: 5,
  value: "Popovers",
  id: "popovers"
}];
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    h4: "h4",
    p: "p",
    strong: "strong",
    details: "details",
    summary: "summary",
    pre: "pre",
    code: "code",
    span: "span",
    h5: "h5",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td"
  }, _provideComponents(), props.components);
  return <><InitMenu />{"\n"}<_components.h1>{"Popovers"}</_components.h1>{"\n"}{"\n"}<_components.h4 id="general">{"General"}</_components.h4>{"\n"}<hr />{"\n"}<_components.p><_components.strong>{"Popovers"}</_components.strong><br />{"\r\nThe floating card pops up when clicking an element."}</_components.p>{"\n"}{"\n"}<Demo />{"\n"}<_components.details><_components.summary>{"Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Popovers "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"pocko-ui/Popovers\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"className"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"mt-4\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Popovers"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"ref"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{popoverRef}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"modalBodyHeight"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// 弹出框高度"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"modalBodyWidth"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// 弹出框宽度"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"content"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"          <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"button"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"className"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"btn btn-sm btn-primary text-dark\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"type"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"button\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            test"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"          </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"button"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"triggerShow"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      >"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"h2"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">This is Popovers' content</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"h2"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Popovers"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  );"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h4 id="customize-height-or-width">{"Customize Height or Width"}</_components.h4>{"\n"}{"\n"}<Demo1 />{"\n"}<_components.details><_components.summary>{"Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Popovers "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"pocko-ui/Popovers\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"class"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"d-flex align-items-center gap-4\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Popovers"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"modalBodyHeight"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"100\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// 弹出框高度"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"modalBodyWidth"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"100\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// 弹出框宽度"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"content"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"button"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"className"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"btn btn-sm btn-primary text-dark\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"type"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"button\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"          100px"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"button"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"triggerShow"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    >"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"h2"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Width: 100px</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"h2"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"h2"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Height: 100px</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"h2"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Popovers"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Popovers"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"modalBodyHeight"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"300\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// 弹出框高度"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"modalBodyWidth"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"300\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// 弹出框宽度"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"content"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"button"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"className"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"btn btn-sm btn-info\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"type"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"button\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"          300px"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"button"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"triggerShow"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"true"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    >"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"h2"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Width: 300px</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"h2"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"h2"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Height: 300px</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"h2"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Popovers"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h4 id="api">{"API"}</_components.h4>{"\n"}<hr />{"\n"}<_components.h5 id="popovers">{"Popovers"}</_components.h5>{"\n"}<_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Popovers "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"pocko-ui/Popovers\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'pocko-ui/Popovers/index.css'"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.table><_components.thead><_components.tr><_components.th>{"Property"}</_components.th><_components.th>{"Type"}</_components.th><_components.th>{"Default"}</_components.th><_components.th>{"Description"}</_components.th><_components.th>{"Required"}</_components.th></_components.tr></_components.thead><_components.tbody><_components.tr><_components.td>{"children"}</_components.td><_components.td>{"ReactNode"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The content to be displayed inside the popover. This can be any valid ReactNode (e.g., text, components, elements)."}</_components.td><_components.td>{"✔"}</_components.td></_components.tr><_components.tr><_components.td>{"modalBodyHeight"}</_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The height of the modal body (popover content area). This should be a string representing a valid CSS height value (e.g., '200px')."}</_components.td><_components.td>{"✔"}</_components.td></_components.tr><_components.tr><_components.td>{"modalBodyWidth"}</_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The width of the modal body (popover content area). This should be a string representing a valid CSS width value (e.g., '300px')."}</_components.td><_components.td>{"✔"}</_components.td></_components.tr><_components.tr><_components.td>{"content"}</_components.td><_components.td>{"string | ReactNode"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The initial content displayed as the trigger for the popover. It can be a string or a ReactNode (e.g., a button or text)."}</_components.td><_components.td>{"✔"}</_components.td></_components.tr><_components.tr><_components.td>{"triggerShow"}</_components.td><_components.td>{"Boolean"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"A boolean flag to control whether the popover should be toggled open or closed on click."}</_components.td><_components.td>{"✔"}</_components.td></_components.tr><_components.tr><_components.td>{"externalClassName"}</_components.td><_components.td>{"any[]"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"An array of external class names to handle clicks outside the popover, ensuring that the popover is not closed when clicking on certain elements."}</_components.td><_components.td>{"No"}</_components.td></_components.tr><_components.tr><_components.td>{"closeFunc"}</_components.td><_components.td>{"Function | any"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"A callback function triggered when the popover is closed. This function is called in the "}<_components.code>{"useEffect"}</_components.code>{" when the popover is closed."}</_components.td><_components.td>{"No"}</_components.td></_components.tr></_components.tbody></_components.table></>;
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}



const __nextraPageOptions = {
  MDXContent,
  pageOpts: {"filePath":"pages/Other/Popovers.html.mdx","route":"/Other/Popovers.html","timestamp":1739774380000,"pageMap":[{"kind":"Folder","name":"Forms","route":"/Forms","children":[{"kind":"MdxPage","name":"Checkbox.html","route":"/Forms/Checkbox.html"},{"kind":"MdxPage","name":"Input.html","route":"/Forms/Input.html"},{"kind":"MdxPage","name":"Radio.html","route":"/Forms/Radio.html"},{"kind":"Meta","data":{"Input.html":"Input🔥","Checkbox.html":"Checkbox","Radio.html":"Radio"}}]},{"kind":"Folder","name":"Getting-Started","route":"/Getting-Started","children":[{"kind":"MdxPage","name":"Installation.html","route":"/Getting-Started/Installation.html"},{"kind":"MdxPage","name":"Usage.html","route":"/Getting-Started/Usage.html"},{"kind":"Meta","data":{"Installation.html":"Installation","Usage.html":"Usage"}}]},{"kind":"MdxPage","name":"index","route":"/"},{"kind":"Folder","name":"Navigation","route":"/Navigation","children":[{"kind":"MdxPage","name":"DropdownMenu.html","route":"/Navigation/DropdownMenu.html"},{"kind":"Meta","data":{"DropdownMenu.html":"DropdownMenu"}}]},{"kind":"Folder","name":"Other","route":"/Other","children":[{"kind":"MdxPage","name":"EmptyNotice.html","route":"/Other/EmptyNotice.html"},{"kind":"MdxPage","name":"Popovers.html","route":"/Other/Popovers.html"},{"kind":"Meta","data":{"EmptyNotice.html":"EmptyNotice🌈","Popovers.html":"Popovers🔈"}}]},{"kind":"Folder","name":"Web-Elements","route":"/Web-Elements","children":[{"kind":"MdxPage","name":"ModalDialog.html","route":"/Web-Elements/ModalDialog.html"},{"kind":"MdxPage","name":"Notification.html","route":"/Web-Elements/Notification.html"},{"kind":"MdxPage","name":"SelectInput.html","route":"/Web-Elements/SelectInput.html"},{"kind":"MdxPage","name":"Table.html","route":"/Web-Elements/Table.html"},{"kind":"MdxPage","name":"ToolTips.html","route":"/Web-Elements/ToolTips.html"},{"kind":"MdxPage","name":"Trees.html","route":"/Web-Elements/Trees.html"},{"kind":"Meta","data":{"ModalDialog.html":"ModalDialog🔥","SelectInput.html":"SelectInput🔥","ToolTips.html":"ToolTips","Table.html":"Table🔥","Trees.html":"Trees","Notification.html":"Notification"}}]},{"kind":"Meta","data":{"index":"Introduction","Getting-Started":{"title":"Getting-Started"},"--":{"type":"separator","title":"Components"},"Web-Elements":{"title":"Web Elements"},"Forms":{"title":"Forms"},"Navigation":{"title":"Navigation"},"Other":{"title":"Other"},"contact":{"title":"Source ↗","type":"page","href":"https://github.com/chennkaibin/pocko-ui","newWindow":true}}}],"flexsearch":{"codeblocks":true},"title":"Popovers",headings:__toc},
  pageNextRoute: "/Other/Popovers.html",
  nextraLayout: __nextra_layout,themeConfig: __nextra_themeConfig
}
if (process.env.NODE_ENV !== 'production') {
  __nextraPageOptions.hot = module.hot
  __nextraPageOptions.pageOptsChecksum = ''
}
if (typeof window === 'undefined') __nextraPageOptions.dynamicMetaModules = []

export default setupNextraPage(__nextraPageOptions)